package game

import com.soywiz.korio.dynamic.serialization.parseTyped
import com.soywiz.korio.dynamic.serialization.stringifyTyped
import com.soywiz.korio.serialization.json.Json

enum class SaveId(val fileName: String) {
    Save1("save1.json"),
    Save2("save2.json"),
    Save3("save3.json"),
}

suspend fun loadState(saveId: SaveId): GameState? {
    return try {
        val json = loadFile(saveId.fileName)

        if (json != null) {
            val mapper = wishlairObjectMapper()

            val saveGame = Json.parseTyped<GameState>(json, mapper)

            if (saveGame.playerLife < 1) {
                saveGame.playerLife = 1
            }

            saveGame
        } else {
            null
        }
    } catch (e: Exception) {
        println(e)

        null
    }
}

suspend fun saveState(saveId: SaveId, gameState: GameState) {
    val mapper = wishlairObjectMapper()

    val json = Json.stringifyTyped(gameState, mapper, true)

    saveFile(saveId.fileName, json)
}
